<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
<userLeft :active="7" />
      <div class="box5">
        <div style="overflow: hidden;">
          <div class="box6" style="float: left;">我的反馈</div>
        </div>
        <div class="box7"></div>
        <div class="add_feedback_title">-您好，感谢使用科隆商城！提交反馈后，您可以在 <span > <router-link to="/my_feedback" style="color: #2B9A34;">“消息通知”</router-link> </span> 中查看反馈处理进度。</div>

          <div style="overflow: hidden;">
            <div class="add_feedback_type">反馈类型</div>
          <div style="overflow: hidden; float: left; width: 80%; margin-left: 2%; margin-top: 2%;">
        <div @click="changType(index)" :class="[ fankuileixin_index == index ? 'xuanzhong' : '', 'add_feedback_type_but', index == 0 ? 'diyige' : '' ]" v-for="(item, index) in fankuileixin">{{item}}</div>
        </div>
          </div>

          <div style="overflow: hidden;">
            <div class="add_feedback_type">反馈内容</div>
        <div class="rich_text_box" id="editorElem"></div>
          </div>

          <div style="overflow: hidden;">
            <div class="add_feedback_type"></div>
        <div class="upload_attachment">

             <div style="float: left;">
                 <a-upload
    name="file"
    :multiple="true"
    action="/api/file/upload"
    @change="handleChange"
    accept=".jpg,.png,.rar,.doc,xls"
  >
    <a-button> <a-icon type="upload" />上传附件</a-button>
  </a-upload>

             </div>

          <div class="upload_attachment_txt">上传附件支持jpg、png、rar、doc、xls格式，最大不超过5M</div>
        </div>
          </div>

          <div style="overflow: hidden;">
            <div class="add_feedback_type">联系手机</div>
        <div style="text-align: left;">
          <a-input v-model="form.userNum" placeholder="请输入手机号" style="width: 300px; margin-top: 20px; margin-left: 20px; float: left;" />
          <div class="mobile_txt">反馈的处理动态，将给你通过短信发送到您的手机</div>
        </div>
          </div>
          <div class="submit_but" style="" @click="submit">提交</div>
      </div>
    </div>
    <foot/>
  </div>
</template>

<script>
    import E from "wangeditor";
    import axios from "axios";
    import userLeft from "../public/user_left";
    import htmlHeader from "../public/head";
    import foot from "../public/foot";
    export default {
        name: "integral",
        components: {
            userLeft,
            htmlHeader,
            foot,
        },
        data() {
            return {
                fankuileixin: [ '建议', '投诉', '关于供应商', '关于代理商', '订单', '其他' ], // 所有反馈类型
                fankuileixin_index: 0, // 反馈类型选中索引
                form: {
                    complaint: "",
                    fettle: "",
                    fileId: [],
                    remarks: "",
                    reply: "",
                    replyer: "",
                    types: "",
                    userId: "",
                    userName: "",
                    userNum: "",
                },
            };
        },
        methods: {
            // 上传附件
            handleChange(e) {
                if (e.file.status === 'done') {
                    this.add_obj.scan[0] = this.img + e.file.response.data.uuid
                }
            },
            // 切换反馈类型
            changType(e) {
                this.fankuileixin_index = e
            },
            // 提交
            submit() {
                if(this.form.complaint == "") {
                    this.$message.error("请输入反馈内容")
                    return false
                }

                if(this.form.userNum == "") {
                    this.$message.error("请输入电话号码")
                    return false
                }

                if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.form.userNum)) {
                    this.$message.error("请输入正确电话号码")
                    return false
                }
                this.form.types = this.fankuileixin[this.fankuileixin_index]
                this.api.add_feedback(this.form)
                    .then(res => {
                        if (res.ok) {
                            this.$message.success('提交成功')
                            this.$router.push('/my_feedback')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
            },
        },
        created() {

        },
        mounted() {
            const editor = new E("#editorElem");
            // 上传
            // editor.customConfig.customUploadImg = (files, insert) => {
            //     const formData = new FormData();
            //     formData.append("file", files[0]);
            //     formData.append("path", "files/ne-icev3-dashboard/content/content/");
            //     axios.post("/public/index.php/test", formData).then(res => {
            //         const result = res.data;
            //         console.log(result);
            //         const data = result.data;
            //         insert(data);
            //     });
            // };
            // 赋值
            editor.config.onchange = (res) => {
                this.form.complaint = res
            }
            editor.create();
        }
    };
</script>

<style scoped>
    /deep/ .w-e-toolbar {
      z-index: 10 !important;
    }
    /deep/ .w-e-text-container {
      z-index: 10 !important;
    }
    .ant-input-affix-wrapper {
        border: 1px solid #EDE9E9;
        border-radius: 5px;
        outline: none;
    }

    .submit_but {
        width: 100px;
        height: 40px;
        border: 1px solid #2B9A34;
        margin: 4% auto;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
        cursor: pointer;
    }

    .mobile_txt {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 16px;
        float: left;
        margin-left: 2%;
        margin-top: 25px;
    }

    .upload_attachment_txt {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        float: left;
        margin-left: 20px;
        margin-top: 5px;
    }

    .upload_attachment {
        text-align: left;
        margin-top: 2%;
        margin-left: 75px;
        overflow: hidden;
    }

    .rich_text_box {
        width: 90%;
        background: pink;
        float: left;
        margin-top: 25px;
        margin-left: 2%;
    }

    .add_feedback_type_but {
        height: 32px;
        border: 1px solid #EDE9E9;
        float: left;
        line-height: 32px;
        margin-left: 2%;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        text-align: center;
        padding: 0 15px;
        cursor: pointer;
    }

    .add_feedback_type {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-top: 25px;
        text-align: left;
        float: left;
    }

    .add_feedback_title {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: left;
        margin-top: 2%;
    }

    .box14 {
        width: 120px;
        height: 32px;
        border: 1px solid #2C9A34;
        float: right;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2C9A34;
    }

    .box13 {
        width: 16.6666%;
        height: 100%;
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
    }

    .box12 {
        width: 100%;
        height: 40px;
        background: #F4F4F4;
        margin-top: 4%;
    }

    .box11 {
        width: 100px;
        height: 32px;
        border: 1px solid #2B9A34;
        margin: 8% auto;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
    }

    .box10 {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FF9629;
        /* line-height: 16px; */
        margin: 4% auto;
    }

    .box9 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin: auto;
    }

    .box8 {
        width: 100%;
        height: 105px;
        background: EEF7EF;
        /* opacity: 0.08; */
        padding-top: 4%;
    }

    .box7 {
        width: 100%;
        height: 1px;
        border-top: 1px solid #E8E6E6;
        margin-top: 2%;
    }

    .box6 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        /* margin-top: 2%; */
        text-align: left;
    }

.box5 {
        min-height: 1023px;
        width: 80%;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: right;
        margin-top: 2%;
        padding: 2%;
    }

    .box3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: Regular;
        color: #666666;
        margin-top: 6%;
    }

    .box4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: left;
        margin-top: 2%;
    }

    .box2 {
        width: 100%;
        height: 45px;
        background: #F2F2F2;
    }
    .diyige {
    margin-left: 0;
}
.xuanzhong {
    border: 1px solid #2B9A34;
    color: #2B9A34;
}
</style>



// WEBPACK FOOTER //
// src/components/add_feedback.vue